import { useTranslation } from "react-i18next";
import { resolvePath, useNavigate } from "react-router-dom";
import { FormBackButton } from "shared/components/button/FormBackButton";
import { FormCancelButton } from "shared/components/button/FormCancelButton";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import {
  FormFooter,
  FormFooterActions,
  FormFooterBreadcrumb,
} from "shared/components/form/FormFooter";
import {
  PageWizardBar,
  usePageWizard,
} from "shared/components/layout/PageWizard";

export const AllocationSetupFooter: React.FC<{
  allowBack?: boolean;
  allocationRuleId?: string;
}> = ({ allowBack }) => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();

  const { basePath, navigateBack } = usePageWizard();

  return (
    <FormFooter>
      <FormFooterBreadcrumb>
        <PageWizardBar />
      </FormFooterBreadcrumb>
      <FormFooterActions>
        {allowBack && (
          <FormBackButton
            onClick={() => {
              navigateBack();
            }}
          />
        )}
        <FormCancelButton
          onClick={() => {
            // up from "setup/:allocationRuleId"
            navigate(resolvePath("../..", basePath));
          }}
        />
        <FormSubmitButton>{t("common:continue")}</FormSubmitButton>
      </FormFooterActions>
    </FormFooter>
  );
};
